import {
  FETCH_ALL_ORDER_BOOK,
  FETCH_ALL_ORDER_BOOK_FAILED,
  FETCH_ALL_ORDER_BOOK_SUCCEED,
  FETCH_BUY_ORDER_BOOK,
  FETCH_BUY_ORDER_BOOK_FAILED,
  FETCH_BUY_ORDER_BOOK_SUCCEED,
  FETCH_SELL_ORDER_BOOK,
  FETCH_SELL_ORDER_BOOK_FAILED,
  FETCH_SELL_ORDER_BOOK_SUCCEED,
  CLICK_ORDER_BOOK_BUY,
  CLICK_ORDER_BOOK_SELL, MAKE_ORDER_BOOK_EMPTY,
} from './action_types';

export default {
  fetchAllOrderBookAction: (data) => ({
    type: FETCH_ALL_ORDER_BOOK,
    params: {
      data,
    },
  }),
  fetchAllOrderBookActionSucceed: (data) => ({
    type: FETCH_ALL_ORDER_BOOK_SUCCEED,
    params: {
      data,
    },
  }),
  fetchAllOrderBookActionFailed: (err) => ({
    type: FETCH_ALL_ORDER_BOOK_FAILED,
    err,
  }),

  fetchBuyOrderBookAction: (data) => ({
    type: FETCH_BUY_ORDER_BOOK,
    params: {
      data,
    },
  }),
  fetchBuyOrderBookActionSucceed: (data) => ({
    type: FETCH_BUY_ORDER_BOOK_SUCCEED,
    params: {
      data,
    },
  }),
  fetchBuyOrderBookActionFailed: (err) => ({
    type: FETCH_BUY_ORDER_BOOK_FAILED,
    err,
  }),

  fetchSellOrderBookAction: (data) => ({
    type: FETCH_SELL_ORDER_BOOK,
    params: {
      data,
    },
  }),
  fetchSellOrderBookActionSucceed: (data) => ({
    type: FETCH_SELL_ORDER_BOOK_SUCCEED,
    params: {
      data,
    },
  }),
  fetchSellOrderBookActionFailed: (err) => ({
    type: FETCH_SELL_ORDER_BOOK_FAILED,
    err,
  }),
  clickOrderBookBuy: (data) => ({
    type: CLICK_ORDER_BOOK_BUY,
    params: {
      data,
    },
  }),
  clickOrderBookSell: (data) => ({
    type: CLICK_ORDER_BOOK_SELL,
    params: {
      data,
    },
  }),
  makeOrderBookEmpty: () => ({
    type: MAKE_ORDER_BOOK_EMPTY,
  }),
};
